export default "__VITE_ASSET__CDODSRbv__"